import { useSetAtom } from "jotai";
import { useLayoutEffect, useRef, useState } from "react";

import { SupportedLanguage } from "@whoosh/design-system/src/components/controls";

import { normalizeLanguage, setActiveClubLanguageSourceAtom } from "./atoms";

export const useActiveClubLanguage = (
  locale?: string | null,
  active = true
) => {
  const sourceId = useRef(Symbol("active-club-language")).current;
  const language = normalizeLanguage(locale);
  const [registeredSource, setRegisteredSource] = useState<{
    language: SupportedLanguage | null;
  } | null>(null);
  const setActiveClubLanguageSource = useSetAtom(
    setActiveClubLanguageSourceAtom
  );

  useLayoutEffect(() => {
    if (!active) {
      return;
    }

    setActiveClubLanguageSource({
      id: sourceId,
      language,
    });
    setRegisteredSource({ language });

    return () => {
      setActiveClubLanguageSource({ id: sourceId, language: null });
    };
  }, [active, language, setActiveClubLanguageSource, sourceId]);

  return !active || registeredSource?.language === language;
};
